import setSearchedLocation from './setSearchedLocation';
import navigateToResults from './navigateToResults';

const setSearchedLocationAndNavigateToResults = location => dispatch => {
  dispatch(setSearchedLocation(location, { saveSync: true }));
  dispatch(navigateToResults(location));
};

export default setSearchedLocationAndNavigateToResults;
